import { Fragment, h } from 'preact'
import { useState } from 'preact/hooks'
import { useDispatch } from 'react-redux'
import { requestAddItemToCart } from '@state/cart/cartSlice'

import { productTypeFlags } from 'constants/productTypes'
import { redirect } from 'utils/misc'
import { Plus, ArrowRight, Check } from 'components/icons'
import toaster from 'features/toaster'

function AddedToCartItem({
	id,
	pictureUrl,
	name,
	attributes,
	shortDescription,
	price,
	priceWithDiscount,
	sku,
	url,
	productType,
}) {
	const dispatch = useDispatch()
	const [added, setAdded] = useState(false)
	const isGroupedProduct = productType === productTypeFlags.groupedProduct

	const handleAddToCart = async () => {
		let attrs = []

		if (attributes && attributes.length > 0) {
			attributes.forEach(a =>
				attrs.push({
					key: `product_attribute_${a.attributeId}`,
					value: a.attributeValueId,
				}),
			)
		}

		attrs = JSON.stringify(attrs)

		await dispatch(requestAddItemToCart({ id }, attrs))
			.then(data => {
				setAdded(true)
			})
			.catch(err => {
				toaster.error(err.message)
			})
	}

	return (
		<article className="added-to-cart__content__products__product">
			<img
				src={pictureUrl?.imageUrl}
				alt={pictureUrl?.alternateText || ''}
				title={pictureUrl?.title}
			/>

			<div className="added-to-cart__content__products__product__details">
				<div className="added-to-cart__content__products__product__details__left">
					{url ? (
						<a href={url} className="added-to-cart__content__products__product__name">
							{name}
						</a>
					) : (
						<span className="added-to-cart__content__products__product__name">
							{name}
						</span>
					)}

					{shortDescription && (
						<span className="added-to-cart__content__products__product__description">
							{shortDescription}
						</span>
					)}

					<span className="added-to-cart__content__products__product__price">
						{priceWithDiscount || price}
					</span>
				</div>

				{!added ? (
					<button
						type="button"
						className="added-to-cart__content__products__product__icon"
						onClick={isGroupedProduct ? () => redirect(url) : handleAddToCart}
					>
						{!isGroupedProduct ? <Plus /> : <ArrowRight />}
					</button>
				) : (
					<div className="added-to-cart__content__products__product__icon --success">
						<Check />
					</div>
				)}
			</div>
		</article>
	)
}

export default AddedToCartItem
